import React, {FC} from 'react';
import {IconButton, Link, makeStyles, Typography} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";
import {EditOutlined as EditIcon, Email, Person, Phone, Home as HomeIcon} from "@material-ui/icons";
import {useHistory, useRouteMatch} from "react-router-dom";
import NumberFormat from 'react-number-format';

const useStyles = makeStyles((theme) => ({
    captionContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
       /* marginBottom: theme.spacing(1)*/
    },
    nameIcon: {
        paddingTop: 3.4,
        paddingRight: 4
    },
    valueContainer: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    }
}));

export type LabeledTextDisplayType = "name" | "phone" | "email" | "address";

export interface LabeledTextDisplayProps {
    label: string;
    type?: LabeledTextDisplayType;
    editIdentifier?: string;
    value?: string | number;
    className?: string;
    suffix?: string;
    currency?: boolean;
    required?: boolean;
}

type IconsMapType = {
    [key in LabeledTextDisplayType]: { icon: React.ReactElement; hrefAction?: string }
}

const iconsMap: IconsMapType = {
    name: {
        icon: <Person fontSize="inherit" color="inherit"/>
    },
    address: {
        icon: <HomeIcon fontSize="inherit" color="inherit"/>
    },
    email: {
        icon: <Email fontSize="inherit" color="inherit"/>,
        hrefAction: 'mailto:'
    },
    phone: {
        icon: <Phone fontSize="inherit" color="inherit"/>,
        hrefAction: 'tel:'
    }
}

export const LabeledTextDisplay: FC<LabeledTextDisplayProps> = ({
                                                                    value,
                                                                    className,
                                                                    label,
                                                                    type,
                                                                    editIdentifier,
                                                                    currency,
                                                                    suffix,
                                                                    required
                                                                }) => {
    const classes = useStyles();
    const history = useHistory();
    const {url} = useRouteMatch();

    const textLinkProps = type && iconsMap[type]?.hrefAction
        ? {
            component: Link,
            href: `${iconsMap[type]?.hrefAction}${value}`
        }
        : {}

    return (
        <div className={className}>
            <div className={classes.captionContainer}>
                {type && (
                    <Typography
                        variant="caption"
                        color="textSecondary"
                        className={classes.nameIcon}
                    >
                        {iconsMap[type]?.icon}
                    </Typography>
                )}
                <Typography variant="caption" color="textSecondary">
                    {label}
                </Typography>
            </div>
         {/*   {value === undefined && required && <Skeleton width={224}/>}
            {value && (
                <div className={classes.valueContainer}>
                    <Typography {...textLinkProps}>
                        {typeof value === "number"
                            ? <NumberFormat
                                value={value}
                                displayType={'text'}
                                thousandSeparator={currency}
                                suffix={suffix}
                                decimalScale={currency ? 2 : undefined}
                                fixedDecimalScale={currency}
                            />
                            : value
                        }
                    </Typography>
                    {editIdentifier && (
                        <IconButton size="small"
                                    onClick={() => history.replace(`${url}?mode=edit#${editIdentifier}`)}>
                            <EditIcon fontSize="inherit"/>
                        </IconButton>
                    )}
                </div>
            ) }*/}
            {(value || !required)
                ? (
                    <div className={classes.valueContainer}>
                        <Typography {...textLinkProps}>
                            {typeof value === "number"
                                ? <NumberFormat
                                    value={value}
                                    displayType={'text'}
                                    thousandSeparator={currency}
                                    suffix={suffix}
                                    decimalScale={2}
                                    fixedDecimalScale={currency}
                                />
                                : value
                            }
                        </Typography>
                        {editIdentifier && (
                            <IconButton size="small"
                                        onClick={() => history.replace(`${url}?mode=edit#${editIdentifier}`)}>
                                <EditIcon fontSize="inherit"/>
                            </IconButton>
                        )}
                    </div>
                )
                : <Skeleton width={224}/>
            }
        </div>
    );
}